"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isObject = _interopRequireDefault(require("./isObject"));

var _default = _isObject.default; // this file exists to align with immutable.js definition of valueObject
// isValueObject ends up being the same as isObject()
// this file is retained for API completeness

exports.default = _default;